import { getheaders } from "./authService";

export async function getOauthUrl() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch('/api/myob/oauth/url', requestOptions);
}

export async function getProfileList() {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch('/api/myob/profiles', requestOptions);
}

export async function getBusinessesAndAccounts(refresh) {
    let requestOptions = {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch(`/api/myob/businessesacounts?refresh=${refresh}`, requestOptions);
}

export async function updateAccountMapping(profileId, businessId, prop, value) {
    let body = {};
    body[prop] = { uid: value };
    let requestOptions = {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(body)
    };
    return fetch(`/api/myob/profiles/${profileId}/businessesacounts/${businessId}/accountsmapping`, requestOptions);
}

export async function deleteProfile(uid) {
    let requestOptions = {
        method: 'DELETE',
        headers: getheaders(),
        redirect: 'follow'
    };
    return fetch(`/api/myob/profile/${uid}`, requestOptions);
}

export async function getAgencyDefaults() {
    return fetch('/api/myob/agency-defaults', {
        method: 'GET',
        headers: getheaders(),
        redirect: 'follow'
    });
}

export async function setAgencyDefault(cosCustomerId, mapping) {
    return fetch(`/api/myob/agency-defaults/${encodeURIComponent(cosCustomerId)}`, {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify(mapping)
    });
}

export async function deleteAgencyDefault(cosCustomerId) {
    return fetch(`/api/myob/agency-defaults/${encodeURIComponent(cosCustomerId)}`, {
        method: 'DELETE',
        headers: getheaders(),
        redirect: 'follow'
    });
}

export async function setBlockOnOverdue(cosCustomerId, enabled) {
    return fetch(`/api/myob/agency-defaults/${encodeURIComponent(cosCustomerId)}/block-on-overdue`, {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify({enabled})
    });
}

export async function refreshAgencyOverdue() {
    return fetch('/api/myob/agency-defaults/refresh-overdue', {
        method: 'POST',
        headers: getheaders(),
        redirect: 'follow'
    });
}

export async function getAgencyOverdueInvoicePdf(cosCustomerId, invoiceUid) {
    const headers = getheaders();
    // Let the API return its JSON validation message when a snapshot has
    // expired, while still accepting the PDF response for a valid invoice.
    headers.set('Accept', '*/*');
    return fetch(
        `/api/myob/agency-defaults/${encodeURIComponent(cosCustomerId)}/overdue-invoices/${encodeURIComponent(invoiceUid)}/pdf`,
        {
            method: 'GET',
            headers,
            redirect: 'follow',
        }
    );
}
